import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';
import { Checkbox as UiCheckbox, InputLabel } from '@plecto/ui';

// The label colour is InputLabel's: dimmed at rest, bright once checked or under the pointer,
// and dimmed again while a checked row is engaged — the same as the box beside it.
const StyledLabel = styled.span``;

export const CheckboxLabel = StyledLabel;

function Checkbox({ className, checked, onToggle, label, image, disabled }) {
	return <InputLabel className="react-form-checkbox" disabled={disabled}>
		<UiCheckbox
			className={classNames('react-form-checkbox-input', className)}
			checked={checked}
			onChange={onToggle}
			disabled={disabled} />
		{image && <img src={image} className={'react-form-checkbox-image'} />}
		<StyledLabel className={classNames('react-form-checkbox-label', {
			'react-form-checkbox-label--disabled': disabled
		})}>{label}</StyledLabel>
	</InputLabel>;
}

Checkbox.propTypes = {
	checked: PropTypes.bool,
	label: PropTypes.string.isRequired,
	className: PropTypes.string,
	onToggle: PropTypes.func.isRequired,
};

export default memo(Checkbox);
